import React, { useEffect } from "react";

import { SurveyModelJson, SurveyQuestionJson } from "@performyard/service-contracts";

import { Survey } from "../../../SurveyAuthoring/pages/AuthorSurvey/components/Survey";

import {
	useActions as useAuthorSurveyActions,
	useSetters as useAuthorSurveySetters,
} from "../../../SurveyAuthoring/pages/AuthorSurvey/store/store";

import useSearchQueryParams from "../../../../../../hooks/useSearchQueryParams";

import BasePageTemplate from "../../../../../../pageTemplates/BasePageTemplate";
import { searchParamsSchema } from "../../SurveyDetails";

export function SurveyPreview({ survey }: { survey: SurveyModelJson }) {
	const sortedQuestions = (survey?.questions || [])
		.filter((question) => !question.deleted)
		.sort((a, b) => a.order - b.order) as SurveyQuestionJson[];
	const authorSurveySetters = useAuthorSurveySetters();
	const authorSurveyActions = useAuthorSurveyActions();
	const { queryParams: searchParams } = useSearchQueryParams({
		schema: searchParamsSchema,
	});

	useEffect(() => {
		if (searchParams.tab === "preview") {
			// enables validation of answers by loading the questions into the store
			authorSurveySetters.setQuestions(sortedQuestions);
		}
		return () => {
			// clears answers when unmounting
			authorSurveyActions.clearAnswers();
		};
	}, [sortedQuestions, searchParams.tab]);

	return (
		<BasePageTemplate title="Survey Preview" backgroundColor="grey">
			<div data-testid="survey-preview" className="mt-[24px] flex flex-col items-center justify-center">
				<Survey isPreview surveyName={survey.name} questions={sortedQuestions} onSubmit={() => {}} />
			</div>
		</BasePageTemplate>
	);
}
